import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

interface ActionButtonsProps {
  onDelete?: () => void;
  editLink?: string;
  onEdit?: () => void;
  deleteLabel?: string;
  editLabel?: string;
  deleteDisabled?: boolean;
  editDisabled?: boolean;
  className?: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onDelete,
  editLink,
  onEdit,
  deleteLabel = 'Delete',
  editLabel = 'Edit',
  deleteDisabled = false,
  editDisabled = false,
  className = ''
}) => {
  // If className includes 'flex-row', use it; otherwise default to flex-col sm:flex-row
  const flexDirection = className.includes('flex-row') ? 'flex-row' : 'flex-col sm:flex-row';
  const cleanClassName = className.replace('flex-row', '').trim();
  
  return (
    <div className={`flex ${flexDirection} gap-2 ${cleanClassName}`}>
      {(editLink || onEdit) && (
        <>
          {editLink ? (
            <Link
              data-track="edit"
              to={editLink}
              data-testid="edit-button"
              aria-label={editLabel}
              className={`inline-flex items-center justify-center sm:justify-start px-4 py-2 border border-edge-input rounded-md shadow-sm text-sm font-medium text-body bg-surface hover:bg-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ${
                editDisabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
              }`}
            >
              <PencilIcon className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">{editLabel}</span>
            </Link>
          ) : (
            <button
              data-track="edit"
              onClick={onEdit}
              disabled={editDisabled}
              data-testid="edit-button"
              aria-label={editLabel}
              className={`inline-flex items-center justify-center sm:justify-start px-4 py-2 border border-edge-input rounded-md shadow-sm text-sm font-medium text-body bg-surface hover:bg-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ${
                editDisabled ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              <PencilIcon className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">{editLabel}</span>
            </button>
          )}
        </>
      )}
      {onDelete && (
        <button
          data-track="delete"
          onClick={onDelete}
          disabled={deleteDisabled}
          aria-label={deleteLabel}
          className={`inline-flex items-center justify-center sm:justify-start px-4 py-2 border border-red-300 rounded-md shadow-sm text-sm font-medium text-red-700 bg-surface hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ${
            deleteDisabled ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          <TrashIcon className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">{deleteLabel}</span>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
